import servicios from '@/components/servicios'
import ARL from '@/components/Servicios/Arl'
import HomeService from '@/components/Servicios/HomeService'
import ServiciosEmpresas from './empresas'
import ServiciosPersonas from './personas'

export default {
    path: '/servicios',
    component: servicios,
    children: [
        {
            path: '',
            name: 'HomeService',
            component: HomeService
        },
        {
            path: 'ARL',
            name: 'ARL',
            component: ARL
        },
        ServiciosEmpresas,
        ServiciosPersonas
    ]
}



// WEBPACK FOOTER //
// ./src/router/servicios.js